export default interface DepartmentSapParameter {
    groupId: number
    fieldName: string
    value: string
}

const requiredFields: string[] = [ 'GLAccount' ]
export function validateDepartmentSapParameters(departmentSapParameter: DepartmentSapParameter[] | undefined): Map<string, string> | undefined {
    const errors = new Map<string, string>();

    if (!departmentSapParameter) {
        departmentSapParameter = [];
    }

    for(const field of requiredFields) {
        const item = departmentSapParameter.find(m => m.fieldName === field);
        if (!item || !item.value || item.value.length === 0) {
            errors.set(field, "Value field is required.");
            break;
        }
    }

    if (errors.size > 0) {
        return errors;
    } else {
        return undefined;
    }
}